/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { displayDate } from "../common/datePresentation";
import { getClassTypeName } from "../common/Helpers";
import { isGroupReportLessonType } from "../common/lessonTypes";

const GroupRow = ({
  reg,
  index,
  expandedRows,
  toggleExpandRow,
  isGroupSelected,
  setSelectedRows,
  lessonTypes,
}) => {
  const { t: tr } = useTranslation();
  const groupSelected = isGroupSelected(reg.id, reg.students);
  let rowClass = "";
  let groupClass = "";
  const isGroupReportRow = isGroupReportLessonType(reg.classType, lessonTypes);

  if (groupSelected) {
    rowClass = "selected-row";
  } else if (index % 2 !== 0) {
    rowClass = "report-table-row-alternate";
  }

  if (isGroupReportRow) {
    groupClass = "Grupa";
  } else if (reg.students[0]) {
    groupClass = reg.students[0].studentName;
  }

  const presentCount = <strong>{`${reg.presentCount}/${reg.maxMembers}`}</strong>;

  return (
    <div className={`report-table-row ${rowClass} group row manage-text`}>
      <div className="col-sm report-expand d-flex align-items-center ml-3">
        <div className="report-checkbox expand-button text-with-icon d-flex justify-content-center ml-2">
          <button
            className="p-0 shadow-none btn btn-transparent expand-button"
            onClick={() => toggleExpandRow(reg.id)}
            type="button"
            style={
              isGroupReportRow
                ? { visibility: "visible", pointerEvents: "auto" }
                : { visibility: "hidden", pointerEvents: "none" }
            }
          >
            <i
              className={`fas ${
                expandedRows.includes(reg.id)
                  ? "fa-minus"
                  : "fa-plus"
              }`}
              style={{ color: "black" }}
            />
          </button>

          <input
            className="ml-3"
            type="checkbox"
            checked={isGroupSelected(reg.id, reg.students)}
            onChange={(e) => {
              const isChecked = e.target.checked;

              setSelectedRows((prevSelectedRows) => {
                const updatedGroupSelection = reg.students.reduce((studentAcc, student) => ({
                  ...studentAcc,
                  [student.id]: isChecked,
                }), {});

                return {
                  ...prevSelectedRows,
                  [reg.id]: updatedGroupSelection,
                };
              });
            }}
          />
        </div>
      </div>

      <div className="col-sm report-date-col text-center" data-label={tr("manage:date_8")}>
        {displayDate(reg.date)}
      </div>
      <div className="col-sm report-weekday-col text-center" data-label={tr("billing:weekday_131")}>
        {reg.dayOfWeek}
      </div>
      <div className="col-sm report-start-time-col text-center" data-label={tr("calendar:time")}>
        {reg.startTime}
      </div>
      <div className="col-sm report-lesson-type-col text-center" data-label={tr("manage:lessonType_196")}>
        {getClassTypeName(reg.classType, lessonTypes)}
      </div>
      <div className="col-sm report-student-col text-center" data-label={tr("manage:student_14")}>
        {groupClass}
      </div>
      <div className="col-sm report-client-col text-center" data-label={tr("manage:client_108")}>
        {isGroupReportRow
          ? ""
          : (reg.students[0] && reg.students[0].clientName) || ""}
      </div>

      <div className="col-sm report-teacher-col text-center" data-label={tr("manage:teacher_226")}>
        {reg.teacherName}
      </div>
      <div className="col-sm report-present-col text-center" data-label={tr("client:present_31")}>
        {presentCount}
      </div>

      <div className="col-sm report-comment-col text-center" data-label={tr("manage:notes_10")}>
        {!isGroupReportRow
          ? reg.students[0].comment
          : ""}
      </div>
    </div>
  );
};

GroupRow.propTypes = {
  reg: PropTypes.shape({
    id: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    dayOfWeek: PropTypes.string.isRequired,
    startTime: PropTypes.string.isRequired,
    classType: PropTypes.string.isRequired,
    teacherName: PropTypes.string.isRequired,
    presentCount: PropTypes.number.isRequired,
    maxMembers: PropTypes.number.isRequired,
    students: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        studentName: PropTypes.string.isRequired,
        isPresent: PropTypes.bool.isRequired,
        comment: PropTypes.string.isRequired,
        clientName: PropTypes.string,
      })
    ).isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
  expandedRows: PropTypes.arrayOf(PropTypes.string).isRequired,
  toggleExpandRow: PropTypes.func.isRequired,
  isGroupSelected: PropTypes.func.isRequired,
  setSelectedRows: PropTypes.func.isRequired,
  lessonTypes: PropTypes.shape({
    id: PropTypes.string,
    types: PropTypes.array,
  }).isRequired,
};

export default GroupRow;
